/*
 * International dialling codes by country, for the checkout's phone field
 * outside India. Countries missing here start the picker blank and the
 * buyer chooses; the phone number is optional there anyway.
 */

const CODES = {
  US: "+1", CA: "+1", PR: "+1",
  GB: "+44", IE: "+353", FR: "+33", DE: "+49", NL: "+31", BE: "+32", LU: "+352",
  CH: "+41", AT: "+43", IT: "+39", ES: "+34", PT: "+351", GR: "+30", MT: "+356",
  CY: "+357", DK: "+45", SE: "+46", NO: "+47", FI: "+358", IS: "+354", PL: "+48",
  CZ: "+420", SK: "+421", HU: "+36", RO: "+40", BG: "+359", HR: "+385", SI: "+386",
  RS: "+381", EE: "+372", LV: "+371", LT: "+370", UA: "+380", TR: "+90",
  AE: "+971", SA: "+966", QA: "+974", KW: "+965", BH: "+973", OM: "+968",
  JO: "+962", LB: "+961", IL: "+972", EG: "+20", MA: "+212", TN: "+216", DZ: "+213",
  NG: "+234", GH: "+233", KE: "+254", ZA: "+27", TZ: "+255", UG: "+256", ET: "+251",
  PK: "+92", BD: "+880", LK: "+94", NP: "+977", MV: "+960",
  SG: "+65", MY: "+60", ID: "+62", TH: "+66", VN: "+84", PH: "+63",
  HK: "+852", TW: "+886", JP: "+81", KR: "+82", CN: "+86",
  AU: "+61", NZ: "+64",
  MX: "+52", BR: "+55", AR: "+54", CL: "+56", CO: "+57", PE: "+51",
};

/** "+44" for GB, or "" when this table doesn't know the country. */
export const dialCodeFor = (country) => CODES[String(country || "").toUpperCase()] || "";

export default CODES;
